/* eslint-disable no-unused-vars */

import React from 'react';
import { withRouter } from 'react-router';
import { Route, Link, Redirect, BrowserRouter as Router, Switch } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { InputGroup, FormControl, Button } from 'react-bootstrap';
import { createBrowserHistory } from "history";

var getParams = function (url) {
  var params = {};
  var parser = document.createElement('a');
  parser.href = url;
  var query = parser.search.substring(1);
  var vars = query.split('&');
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split('=');
    params[pair[0]] = decodeURIComponent(pair[1]);
  }
  return params;
};

class Filter extends React.Component {
  constructor(props) {
    super();
    const { match } = props;
    this.state = {
      Filter: false,
      isFilter: false,
      apiUrl: window.$apiUrl,
      CountryList: [],
      ProjectList: [],
      SchoolList: [],
      ThemeList: [],
      SortBy: 2,
      SortingValue: "Story_Title desc",
      urlParams: {
        Title: "",
        Country: "",
        Project: "",
        School: "",
        Theme: ""
      },
      FilterMessage: {
        Title: "",
        Country: "",
        Project: "",
        School: "",
        Theme: ""
      },
      isFiltered: false,
      disableFilter: true
    };

    this.setIsShown = this.setIsShown.bind(this);
    this.setIsShown2 = this.setIsShown2.bind(this);
    this.openFilter = this.openFilter.bind(this);
    this.sorting = this.sorting.bind(this);
    this.FilterStory = this.FilterStory.bind(this);
    this.clearFilter = this.clearFilter.bind(this);
    this.FilterChange = this.FilterChange.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);

    this.wrapperRef = React.createRef();
    this.wrapperRef2 = React.createRef();
  }

  clearFilter() {
    const history = createBrowserHistory();

    this.setState({disableFilter: true});

    setTimeout(() => {
      this.setState({disableFilter: false});
    }, 500)

    var urlParams = this.state.urlParams;
    let FilterMessage = this.state.FilterMessage;

    this.StoryTitle.value = "";
    this.CountryOpt.value = "";
    this.SchoolOpt.value = "";
    this.ProjectOpt.value = "";
    this.ThemeOpt.value = "";

    history.push({
      pathname: '/yep/stories',
      search: ''
    })

    urlParams = {
      Title: "",
      Country: "",
      Project: "",
      School: "",
      Theme: ""
    }

    FilterMessage = {
      Title: "",
      Country: "",
      Project: "",
      School: "",
      Theme: ""
    }

    this.setState({ urlParams: urlParams, SortBy: 2, FilterMessage: FilterMessage, isFiltered: false });
    this.props.FilterStory(this.StoryTitle.value, this.CountryOpt.value, this.SchoolOpt.value, this.ProjectOpt.value, this.ThemeOpt.value, 'Story_Title desc');
  }

  FilterStory(isFilter) {
    this.setState({disableFilter: true, Filter: false });

    setTimeout(() => {
      this.setState({disableFilter: false});
    }, 500)

    const history = createBrowserHistory();
    //const parseQueryString = require('query-string');
    let FilterMessage = this.state.FilterMessage;
    const filterValue = getParams(window.location.href);
    var isFiltered = false;
    if (isFilter) {
     
      var Title = this.StoryTitle ? this.StoryTitle.value : null;
      var Country = this.CountryOpt ? this.CountryOpt.value : null;
      var School = this.SchoolOpt ? this.SchoolOpt.value : null;
      var Project = this.ProjectOpt ? this.ProjectOpt.value : null;
      var Theme = this.ThemeOpt ? this.ThemeOpt.value : null;

      FilterMessage.Title = Title;
      this.setState({ FilterMessage: FilterMessage });

      if (Title || Country || School || Project || Theme) {
        isFiltered = true;
        this.setState({ isFiltered: isFiltered });
      }else{
        isFiltered = false;
        this.setState({ isFiltered: isFiltered });
      }

      var TitleParams = 'Title=' + Title;
      var CountryParams = Country ? '&Country=' + Country : "";
      var SchoolParams = School ? '&School=' + School : "";
      var ProjectParams = Project ? '&Project=' + Project : "";
      var ThemeParams = Theme ? '&Theme=' + Theme : "";

      this.GetSchool(School);
      this.getCountry(Country);
      this.GetProject(Project);
      this.getTheme(Theme);

      history.push({
        pathname: '/yep/stories',
        search: '?' + TitleParams + CountryParams + SchoolParams + ProjectParams + ThemeParams
      })
      this.props.FilterStory(Title, Country, School, Project, Theme, this.state.SortingValue);
    } else {
      var urlParams = this.state.urlParams;

      var Title = filterValue.Title ? filterValue.Title : "";
      var Country = filterValue.Country ? parseInt(filterValue.Country) : "";
      var School = filterValue.School ? parseInt(filterValue.School) : "";
      var Project = filterValue.Project ? parseInt(filterValue.Project) : "";
      var Theme = filterValue.Theme ? parseInt(filterValue.Theme) : "";

      FilterMessage.Title = Title;
      this.setState({ FilterMessage: FilterMessage });

      if (Title || Country || School || Project || Theme) {
        isFiltered = true;
        this.setState({ isFiltered: isFiltered });
      }else{
        isFiltered = false;
        this.setState({ isFiltered: isFiltered });
      }

      this.GetSchool(filterValue.School);
      this.getCountry(filterValue.Country);
      this.GetProject(filterValue.Project);
      this.getTheme(filterValue.Theme);

      urlParams = {
        Title: Title,
        Country: Country,
        Project: Project,
        School: School,
        Theme: Theme
      }

      this.StoryTitle.value = Title;
      this.CountryOpt.value = Country;
      this.SchoolOpt.value = School;
      this.ProjectOpt.value = Project;
      this.ThemeOpt.value = Theme;

      this.setState({ urlParams: urlParams });
      this.props.FilterStory(Title, Country, School, Project, Theme, this.state.SortingValue);
    }
  }

  FilterChange(e, category) {
    var urlParams = this.state.urlParams;
    switch (category) {
      case 'country':
        urlParams.Country = e.target.value
        break;
      case 'school':
        urlParams.School = e.target.value
        break;
      case 'project':
        urlParams.Project = e.target.value
        break;
      case 'theme':
        urlParams.Theme = e.target.value
        break;
      default:
      //nothing
    }
    this.setState({ urlParams: urlParams });

  }

  handleClickOutside(event) {
    if (this.state.Filter) {
      if ((this.wrapperRef && !this.wrapperRef.current.contains(event.target)) && this.wrapperRef2 && !this.wrapperRef2.current.contains(event.target)) {
        //this.props.toggleMenu(false);
        this.setState({ Filter: false });
      }
    }

  }

  sorting(e, val) {
    var urlParams = this.state.urlParams;
    var sortValue = "";
    if (val === 1) {
      sortValue = 'Story_Title asc';
    } else if (val === 2) {
      sortValue = 'Story_Title desc';
    } else if (val === 3) {
      sortValue = 'Story_CreatedDate desc';
    } else if (val === 4) {
      sortValue = 'Story_CreatedDate asc';
    }
    this.setState({disableFilter: true});

    setTimeout(() => {
      this.setState({disableFilter: false});
    }, 500)

    this.setState({ SortBy: val, SortingValue: sortValue });
    this.props.FilterStory(urlParams.Title, urlParams.Country, urlParams.School, urlParams.Project, urlParams.Theme, sortValue);
  }

  getCountry(id) {
    fetch(this.state.apiUrl + '/CommonAPI/GetCountry', {
      method: 'POST',
      headers: {
        'token': process.env.REACT_APP_API_TOKEN,
        'Content-Type': 'application/json; charset=utf-8',
        'access-control-allow-origin': '*'
      },
      body: JSON.stringify({
        "ID": null
      })
    })
      .then(res => res.json())
      .then((data) => {
        if (data.Status === 'OK') {
          this.setState({ CountryList: data.ListingDetail });
        }

      })
      .catch(console.log);

    if (id) {
      let FilterMessage = this.state.FilterMessage;
      fetch(this.state.apiUrl + '/CommonAPI/GetCountry', {
        method: 'POST',
        headers: {
          'token': process.env.REACT_APP_API_TOKEN,
          'Content-Type': 'application/json; charset=utf-8',
          'access-control-allow-origin': '*'
        },
        body: JSON.stringify({
          "ID": id
        })
      })
        .then(res => res.json())
        .then((data) => {
          if (data.Status === 'OK') {
            FilterMessage.Country = data.ListingDetail[0].Listing_Name;
            this.setState({ FilterMessage: FilterMessage });
          }

        })
        .catch(console.log);
    }
  }

  GetProject(id) {
    fetch(this.state.apiUrl + '/CommonAPI/GetProject', {
      method: 'POST',
      headers: {
        'token': process.env.REACT_APP_API_TOKEN,
        'Content-Type': 'application/json; charset=utf-8',
        'access-control-allow-origin': '*'
      },
      body: JSON.stringify({
        "ID": null
      })
    })
      .then(res => res.json())
      .then((data) => {
        if (data.Status === 'OK') {
          this.setState({ ProjectList: data.ListingDetail });
        }
      })
      .catch(console.log);
    if (id) {
      let FilterMessage = this.state.FilterMessage;
      fetch(this.state.apiUrl + '/CommonAPI/GetProject', {
        method: 'POST',
        headers: {
          'token': process.env.REACT_APP_API_TOKEN,
          'Content-Type': 'application/json; charset=utf-8',
          'access-control-allow-origin': '*'
        },
        body: JSON.stringify({
          "ID": id
        })
      })
        .then(res => res.json())
        .then((data) => {
          if (data.Status === 'OK') {
            FilterMessage.Project = data.ListingDetail[0].Listing_Name;
            this.setState({ FilterMessage: FilterMessage });
          }
        })
        .catch(console.log);
    }
  }

  GetSchool(id) {
    fetch(this.state.apiUrl + '/CommonAPI/GetSchool', {
      method: 'POST',
      headers: {
        'token': process.env.REACT_APP_API_TOKEN,
        'Content-Type': 'application/json; charset=utf-8',
        'access-control-allow-origin': '*'
      },
      body: JSON.stringify({
        "ID": null
      })
    })
      .then(res => res.json())
      .then((data) => {
        if (data.Status === 'OK') {
          this.setState({ SchoolList: data.ListingDetail });
        }
      })
      .catch(console.log);

    if (id) {
      let FilterMessage = this.state.FilterMessage;
      fetch(this.state.apiUrl + '/CommonAPI/GetSchool', {
        method: 'POST',
        headers: {
          'token': process.env.REACT_APP_API_TOKEN,
          'Content-Type': 'application/json; charset=utf-8',
          'access-control-allow-origin': '*'
        },
        body: JSON.stringify({
          "ID": id
        })
      })
        .then(res => res.json())
        .then((data) => {
          if (data.Status === 'OK') {
            FilterMessage.School = data.ListingDetail[0].Listing_Name;
            this.setState({ FilterMessage: FilterMessage });
          }
        })
        .catch(console.log);
    }

  }

  getTheme(id) {
    fetch(this.state.apiUrl + '/CommonAPI/GetTheme', {
      method: 'POST',
      headers: {
        'token': process.env.REACT_APP_API_TOKEN,
        'Content-Type': 'application/json; charset=utf-8',
        'access-control-allow-origin': '*'
      },
      body: JSON.stringify({
        "ID": null,
        "Challenge_ID": null,
        "Start_Index": 1,
        "Max_Rows": 1000
      })
    })
      .then(res => res.json())
      .then((data) => {
        this.setState({ ThemeList: data.ListingDetail });
      })
      .catch(console.log);

    if (id) {
      let FilterMessage = this.state.FilterMessage;
      fetch(this.state.apiUrl + '/CommonAPI/GetTheme', {
        method: 'POST',
        headers: {
          'token': process.env.REACT_APP_API_TOKEN,
          'Content-Type': 'application/json; charset=utf-8',
          'access-control-allow-origin': '*'
        },
        body: JSON.stringify({
          "ID": id,
          "Challenge_ID": null,
          "Start_Index": 1,
          "Max_Rows": 1000
        })
      })
        .then(res => res.json())
        .then((data) => {
          FilterMessage.Theme = data.ListingDetail[0].Listing_Name;
          this.setState({ FilterMessage: FilterMessage });
        })
        .catch(console.log);

    }
  }

  openFilter() {
    this.setState({ Filter: !this.state.Filter });
  }

  setIsShown(e, isChange) {
    if (isChange && e.target.querySelector('img')) {
      if (this.state.SortBy === 1) {
        e.target.querySelector('img').src = "./images/sortAlphabet2.png";
      } else {
        e.target.querySelector('img').src = "./images/sortAlphabet2.png";
      }

    } else if (!isChange && e.target.querySelector('img')) {
      if (this.state.SortBy === 1) {
        e.target.querySelector('img').src = "./images/sortAlphabet2.png";
      } else {
        e.target.querySelector('img').src = "./images/sortAlphabetBlue2.png";
      }
    }

  }

  setIsShown2(e, isChange) {
    if (isChange && e.target.querySelector('img')) {
      if (this.state.SortBy === 2) {
        e.target.querySelector('img').src = "./images/sortAlphabet1.png";
      } else {
        e.target.querySelector('img').src = "./images/sortAlphabet1.png";
      }

    } else if (!isChange && e.target.querySelector('img')) {
      if (this.state.SortBy === 2) {
        e.target.querySelector('img').src = "./images/sortAlphabet1.png";
      } else {
        e.target.querySelector('img').src = "./images/sortAlphabetBlue1.png";
      }
    }
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
    this.GetSchool();
    this.getCountry();
    this.GetProject();
    this.getTheme();

    this.FilterStory(false);
  }

  render() {
    const urlParams = this.state.urlParams;

    return (
      <div>
        <div id="Filter" className="Filter row d-flex justify-content-center pb-2">
          <div className="col-md-6 position-relative p-md-0">
            <InputGroup>
              <FormControl
                defaultValue={urlParams.Title}
                ref={el => this.StoryTitle = el}
                placeholder="Search by: Title"
              />
              <InputGroup.Append>
                <button className="btn btn-outline-primary" disabled={this.state.disableFilter} onClick={() => this.FilterStory(true)}>Search</button>
                <Button variant="primary"  ref={this.wrapperRef2} onClick={this.openFilter}><img src="./images/slider.png" className="icons-sm" /></Button>
              </InputGroup.Append>
            </InputGroup>
            <div className={this.state.Filter ? 'position-absolute dropdown-filter p-3 d-block' : 'position-absolute dropdown-filter p-3 d-none'} ref={this.wrapperRef} >
              <select className="form-control mb-2" ref={el => this.CountryOpt = el} value={urlParams.Country} onChange={(e) => this.FilterChange(e, 'country')}>
                <option value="">Select a Country...</option>
                {
                  this.state.CountryList.map((option, optIndex) => {
                    return (
                      <option key={optIndex} value={option.Listing_ID}>{option.Listing_Name}</option>
                    );
                  })

                }
              </select>
              <select className="form-control mb-2" ref={el => this.SchoolOpt = el} value={urlParams.School} onChange={(e) => this.FilterChange(e, 'school')}>
                <option value="">Select a Organization...</option>
                {
                  this.state.SchoolList.map((option, optIndex) => {
                    return (
                      <option key={optIndex} value={option.Listing_ID}>{option.Listing_Name}</option>
                    );
                  })

                }
              </select>
              <select className="form-control mb-2" ref={el => this.ProjectOpt = el} value={urlParams.Project} onChange={(e) => this.FilterChange(e, 'project')}>
                <option value="">Select a Project...</option>
                {
                  this.state.ProjectList.map((option, optIndex) => {
                    return (
                      <option key={optIndex} value={option.Listing_ID}>{option.Listing_Name}</option>
                    );
                  })

                }
              </select>
              {this.state.ThemeList && <select className="form-control mb-2" ref={el => this.ThemeOpt = el} value={urlParams.Theme} onChange={(e) => this.FilterChange(e, 'theme')}>
                <option value="">Select a Theme...</option>
                {
                  this.state.ThemeList.map((option, optIndex) => {
                    return (
                      <option key={optIndex} value={option.Listing_ID}>{option.Listing_Name}</option>
                    );
                  })

                }
              </select>}

              <div>
                <button className="btn btn-primary w-100" disabled={this.state.disableFilter} onClick={() => this.FilterStory(true)}>Filter</button>
              </div>
            </div>

          </div>
        </div>

        <div className="Filter row d-flex justify-content-center pb-4">
          <button className={this.state.SortBy === 1 ? 'btn btn-primary mr-2' : 'btn btn-outline-primary mr-2'} disabled={this.state.disableFilter} onMouseEnter={(e) => this.setIsShown(e, true)} onMouseLeave={(e) => this.setIsShown(e, false)} onClick={(e) => this.sorting(e, 1)}><img src={this.state.SortBy === 1 ? './images/sortAlphabet2.png' : './images/sortAlphabetBlue2.png'} className="icons-sm" /></button>
          <button className={this.state.SortBy === 2 ? 'btn btn-primary mr-2' : 'btn btn-outline-primary mr-2'} disabled={this.state.disableFilter} onMouseEnter={(e) => this.setIsShown2(e, true)} onMouseLeave={(e) => this.setIsShown2(e, false)} onClick={(e) => this.sorting(e, 2)}><img src={this.state.SortBy === 2 ? './images/sortAlphabet1.png' : './images/sortAlphabetBlue1.png'} className="icons-sm" /></button>
          <button className={this.state.SortBy === 3 ? 'btn btn-primary mr-2' : 'btn btn-outline-primary mr-2'} disabled={this.state.disableFilter} onClick={(e) => this.sorting(e, 3)}>Newest</button>
          <button className={this.state.SortBy === 4 ? 'btn btn-primary mr-2' : 'btn btn-outline-primary mr-2'} disabled={this.state.disableFilter} onClick={(e) => this.sorting(e, 4)}>Oldest</button>
          <button className="btn btn-danger" disabled={this.state.disableFilter} onClick={() => this.clearFilter()}>Clear</button>
        </div>

        {this.state.isFiltered && <div className="text-center mb-3">
          <small>
            <span>Filter by : &nbsp;</span>
            {this.state.FilterMessage.Title && <div className="p-2 d-inline-block filterTag mx-2">{this.state.FilterMessage.Title}</div>}

            {this.state.FilterMessage.Country && <div className="p-2 d-inline-block filterTag mx-2">{this.state.FilterMessage.Country}</div>}

            {this.state.FilterMessage.School && <div className="p-2 d-inline-block filterTag mr-2">{this.state.FilterMessage.School}</div>}

            {this.state.FilterMessage.Project && <div className="p-2 d-inline-block filterTag mr-2">{this.state.FilterMessage.Project}</div>}

            {this.state.FilterMessage.Theme && <div className="p-2 d-inline-block filterTag">{this.state.FilterMessage.Theme}</div>}

          </small>
        </div>}
      </div>

    );
  }
}
export default Filter;
